module.exports = __webpack_public_path__ + "img/be.1d636b06.svg";